import React, { useEffect, createElement } from 'react';
import { AdvertorialPage } from './pages/AdvertorialPage';
const META_PIXEL_ID = '932263746333538';
export function App() {
  useEffect(() => {
    document.title = "The 10-Minute Evening Ritual That's Giving Women Over 50 Their Bodies Back";
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) return;
    // Standard Meta Pixel base code
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <AdvertorialPage data-id="element-0" />;
}